import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import getLocaleMessages from '../../utils/localesMessages';
import { getVoucherDetail } from '../partner/utils/partnerUtils';
import {
  Accordion,
  AccordionRow,
  BodyText,
  CaptionText,
  Divider,
  Icon,
  Row,
} from '@paypalcorp/pp-react';

const { phoneComponent: { voucher = {} } = {} } =
  getLocaleMessages('buttonsV3/partner');

const VoucherPreviewComponent = ({ offerProgram, receiverName }) => {
  const voucherMessageHeader = _get(voucher, 'message.header', '').split(
    '{messageMerchantName}'
  );
  const { voucherDetails, discountTagline } = getVoucherDetail({
    offerProgram,
  });

  const voucherHeading = (
    <div className="voucher-header">
      <Icon name="gift" as="i" size="sm" className="gift-icon" />
      <CaptionText
        dangerouslySetInnerHTML={{
          __html: discountTagline,
        }}
      ></CaptionText>
    </div>
  );

  return (
    <Row className="common-preview-component-voucher-accordion bf-margin-top-24">
      <Accordion name="voucherAccordion" className="voucher-accordion">
        <AccordionRow heading={voucherHeading}>
          <Divider className="voucher-accordion-divider" />
          <div className="voucher-accordion-body">
            <BodyText className="voucher-message-from">
              {_get(voucherMessageHeader, '0', '')}
              <b>{receiverName}</b>
              {_get(voucherMessageHeader, '1', '')}
            </BodyText>
            <BodyText className="voucher-detail">{`"${voucherDetails}"`}</BodyText>
          </div>
        </AccordionRow>
      </Accordion>
    </Row>
  );
};

VoucherPreviewComponent.propTypes = {
  offerProgram: PropTypes.object,
  receiverName: PropTypes.string,
};

export default VoucherPreviewComponent;
